document.addEventListener('DOMContentLoaded', () => {

    let imagesSliders = document.querySelectorAll('.images-sliders');
    if(imagesSliders){
        imagesSliders.forEach((item)=>{
            new Swiper(item, {
                rewind: true,
                effect: "fade",
                speed: 3000,
                fadeEffect: {
                    "crossFade": true
                },
                autoplay: {
                    delay: 6000,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: ".pagination-images",
                    clickable: true,
                },
                navigation: {
                    nextEl: ".sw-but-img-next",
                    prevEl: ".sw-but-img-prev",
                },
            });
        });
    }

    let swiperTop = document.querySelectorAll('.swiper-top');
    if(swiperTop){
        swiperTop.forEach((item)=>{
            new Swiper(item, {
                loop: true,
                effect: "fade",
                speed: 1000,
                fadeEffect: {
                    "crossFade": true
                },
                autoplay: {
                    delay: 4000,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: ".pagination-hero",
                    clickable: true,
                }
            });
        });
    }

    let gallerySlider = document.querySelectorAll('.gallery-slider');
    if(gallerySlider){
        gallerySlider.forEach((item)=> {
            new Swiper(item, {
                loop: true,
                effect: "fade",
                speed: 1000,
                uniqueNavElements: false,
                fadeEffect: {
                    "crossFade": true
                },
                navigation: {
                    nextEl: ".sw-gal-next",
                    prevEl: ".sw-gal-prev",
                },
                pagination: {
                    el: ".pagination-gallery",
                    clickable: true,
                }
            });
        });
    }

    let slideSlider = document.querySelectorAll('.slide-slider');
    if(slideSlider){
        slideSlider.forEach((item)=> {
            new Swiper(item, {
                loop: true,
                effect: "fade",
                speed: 1000,
                autoHeight: true,
                uniqueNavElements: false,
                fadeEffect: {
                    "crossFade": true
                },
                autoplay: {
                    delay: 8000,
                    disableOnInteraction: false,
                },
                navigation: {
                    nextEl: ".sw-sli-next",
                    prevEl: ".sw-sli-prev",
                },
                pagination: {
                    el: ".pagination-slider",
                    clickable: true,
                }
            });
        });
    }

    let cardSlider = document.querySelectorAll('.card-slider');
    if(cardSlider){
        cardSlider.forEach((item)=> {
            new Swiper(item, {
                loop: true,
                slidesPerView: 1,
                spaceBetween: 30,
                speed: 1000,
                fadeEffect: {
                    "crossFade": true
                },
                pagination: {
                    el: ".pagination-card",
                    clickable: true,
                },
                breakpoints: {
                    1030: {
                        slidesPerView: 3,
                        spaceBetween: 65,
                    },
                    760: {
                        slidesPerView: 2,
                    }
                }
            });
        });
    }

    let reviewsSlider = document.querySelectorAll('.reviews-slider');
    if(reviewsSlider){
        reviewsSlider.forEach((item)=>{
            new Swiper(item, {
                loop: true,
                effect: "fade",
                speed: 1000,
                autoHeight: true,
                fadeEffect: {
                    "crossFade": true
                },
                autoplay: {
                    delay: 8000,
                    disableOnInteraction: false,
                },
                pagination: {
                    el: ".pagination-reviews",
                    clickable: true,
                }
            });
        });
    }

});